import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "../store/types";

export const getTranslateSelector = createSelector(
  (state: RootState) => state.translate,
  (translate) => translate,
);

export const getTranslatedContentSelector = createSelector(
  getTranslateSelector,
  (translate) => translate?.translatedContent,
);

export const getTranslatePendingSelector = createSelector(
  getTranslateSelector,
  (translate) => translate?.isPending,
);

export const getTranslateErrorSelector = createSelector(
  getTranslateSelector,
  (translate) => translate?.isError,
);
